import type React from "react";
import { MdOutlineCheckCircle } from "react-icons/md";

interface UserInfo {
    label: string;
    value: React.ReactNode;
}

export function SuccessCard({ info, title }: { info: UserInfo[]; title: string }) {
    return (
            <main className="flex-1 flex flex-col items-center justify-center px-4">
                <div className="w-full max-w-md">
                    <div className="flex flex-col gap-4 justify-center items-center">
                        <div className="flex flex-col gap-2 items-center text-green-900">
                            <MdOutlineCheckCircle className="text-5xl" />
                            <h2 className="text-xl font-bold mt-2 text-center">
                                {title}
                            </h2>
                        </div>

                        <div className="border rounded-md border-gray-300 w-full shadow-sm">
                            <div className="bg-gray-50 px-4 py-2 font-semibold text-sm">
                                Cliente
                            </div>
                            {info.map((item, idx) => (
                                <div
                                    key={idx}
                                    className={`grid grid-cols-2 px-4 py-2 text-sm ${idx % 2 === 0 ? 'bg-white' : 'bg-[#F8F9F9]'
                                        }`}
                                >
                                    <span className="text-gray-500 font-medium">{item.label}</span>
                                    <span className="text-gray-800 font-medium text-xs">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </main>
    )
}